import { useAuth } from "../../app/useAuth";
import { EnrichmentCacheProvider } from "./EnrichmentCacheProvider.jsx";

/**
 * Reads the current auth user inside AuthProvider's tree, then renders
 * EnrichmentCacheProvider with the live UID. EnrichmentCacheProvider clears
 * its in-memory cache when this value transitions, isolating cached titles
 * between user sessions on the same browser tab (defense-in-depth for the
 * calendar-cache-privacy plan).
 */
export function AuthScopedEnrichmentCacheProvider({
  children,
  registry,
  tokenProviders,
}) {
  const { user } = useAuth();
  return (
    <EnrichmentCacheProvider
      registry={registry}
      tokenProviders={tokenProviders}
      currentUserId={user?.uid || null}
    >
      {children}
    </EnrichmentCacheProvider>
  );
}
